import actions from '../../actionTypes';

export default (siteId, nodeAddress) => {
  return {
    type: actions.DELETE_SITE_AP,
    siteId,
    nodeAddress
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/deleteSiteAccessPoint.js